module.exports = __webpack_public_path__ + "img/mastercard.e25f183f.svg";